import { render, staticRenderFns } from "./MigrationsHistoryTable.vue?vue&type=template&id=9e61fb42"
import script from "./MigrationsHistoryTable.vue?vue&type=script&lang=js"
export * from "./MigrationsHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports